import {isChristmasSeason, isHalloweenSeason} from '@Utils/seasonal-promotion.util';

export enum SeasonName {
  HALLOWEEN = 'HALLOWEEN',
  CHRISTMAS = 'CHRISTMAS',
}

export const getCurrentSeasonName = (): SeasonName | undefined => {
  if (isHalloweenSeason()) {
    return SeasonName.HALLOWEEN;
  }

  if (isChristmasSeason()) {
    return SeasonName.CHRISTMAS;
  }

  return undefined;
};
